export const NO_TEAM_ID = '__UNASSIGNED_TEAM__';
